import type { Factory } from 'walden-fast/types/mocks';
import type { OffsetPurchase } from 'walden-fast/types/offset-purchase';

const MOCK_OFFSET_PURCHASE: OffsetPurchase = {
  id: '1',
  date: new Date('2025-02-23'),
  included: false,
  totalCo2Tonnes: 0.9,
  totalTrees: 2,
  purchaseAmount: 0,
  purchaseAmountCurrency: 'EUR',
  purchaseProcessed: true,
};

export const offsetPurchaseFactory: Factory<OffsetPurchase> = (overrides) => {
  const included = Math.random() > 0.3;
  const totalTrees = included ? 1 : Math.round(Math.random() * 100);
  return {
    ...MOCK_OFFSET_PURCHASE,
    id: `${Math.floor(Math.random() * 1000000000)}`,
    totalTrees,
    totalCo2Tonnes: Math.round(totalTrees * 0.9 * 100) / 100,
    purchaseAmount: included ? 0 : totalTrees * 1.5,
    purchaseProcessed: Math.random() > 0.5,
    included,
    ...overrides,
  };
};
